import { render, staticRenderFns } from "./u-chip-flat-pill.vue?vue&type=template&id=d9f6e9bc&scoped=true&"
import script from "./u-chip-flat-pill.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f6e9bc",
  null
  
)

export default component.exports